import axios from "axios";
import { API_URL } from "../apiConfig";

// =====================================
// 🔐 Token Helper
// =====================================
const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// =====================================
// 👤 USERS
// =====================================
export const getAllUsers = async () => {
  const response = await axios.get(`${API_URL}/api/users`, {
    headers: authHeader(),
  });
  return response.data;
};

// Usuarios con permiso para añadir notas (Writer / Responsible)
export const getUsersWithAddNotesPermission = async () => {
  const response = await axios.get(`${API_URL}/api/users/add-notes`, {
    headers: authHeader(),
  });

  return response.data;
};

export const getUserById = async (id) => {
  const response = await axios.get(`${API_URL}/api/users/${id}/permissions`, {
    headers: authHeader(),
  });
  return response.data;
};

export const updateUserPermissions = async (id, permissions) => {
  const response = await axios.put(
    `${API_URL}/api/users/${id}/permissions`,
    permissions,
    { headers: authHeader() },
  );
  return response.data;
};

// =====================================
// ✍️ FIRMA (PNG BASE64 DEL USUARIO)
// =====================================
export const saveFirmaBase64 = async (email, firmaBase64) => {
  const response = await axios.post(
    `${API_URL}/api/user-documents/firma/${encodeURIComponent(email)}`,
    { firma: firmaBase64 },
    { headers: authHeader() },
  );
  return response.data;
};

// =====================================
// 📄 DOCUMENTOS DEL USUARIO
// =====================================
export const uploadDocumentoUsuario = async (email, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post(
    `${API_URL}/api/user-documents/upload/${encodeURIComponent(email)}`,
    formData,
    { headers: { ...authHeader(), "Content-Type": "multipart/form-data" } },
  );

  return response.data;
};

export const getDocumentosUsuario = async (email) => {
  const token = localStorage.getItem("token");
  const normalized = email.toLowerCase();
  const response = await axios.get(
    `${API_URL}/api/user-documents/by-email/${normalized}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
};

export const deleteDocumentoUsuario = async (documentId) => {
  const response = await axios.delete(
    `${API_URL}/api/user-documents/delete/${documentId}`,
    { headers: authHeader() },
  );
  return response.data;
};

// =====================================
// ✍️ FIRMA DE DOCUMENTO INDIVIDUAL
// =====================================
export const firmarDocumentoIndividual = async (documentId) => {
  const response = await axios.post(
    `${API_URL}/api/user-documents/${documentId}/firmar`,
    {},
    { headers: authHeader() },
  );
  return response.data;
};

// Obtener estado de firma del documento
export const getEstadoFirmaDocumento = async (documentId) => {
  const response = await axios.get(
    `${API_URL}/api/user-documents/${documentId}/firma`,
    { headers: authHeader() },
  );
  return response.data;
};

// =====================================
// 📥 DESCARGA PDF FIRMADO
// =====================================
export const downloadDocumentoFirmado = async (documentId) => {
  const response = await axios.get(
    `${API_URL}/api/user-documents/${documentId}/download-signed`,
    { headers: authHeader(), responseType: "blob" },
  );
  return response.data;
};

// CHINA
export const updateProveedoresPermitidos = async (id, proveedores) => {
  const response = await axios.put(
    `${API_URL}/api/users/${id}/proveedores-permitidos`,
    { proveedoresPermitidos: proveedores },
    { headers: authHeader() },
  );
  return response.data;
};
